import {
  FormControl,
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format, parseISO, isValid } from "date-fns";

import SmartyAutoComplete from "../../../../../../../global/SmartyAutoComplete";

import AutoCompleteSearch from "./AutoCompleteSearch";

export default function DynamicInput({
  activeEditObj,
  apiUrl,
  customLimit,
  displayNameKey,
  keyVal,
  nullable,
  responseSuccess,
  setVal,
  title,
  type,
  val,
}) {
  if (type === "text" || type === "number") {
    return (
      <TextField
        className="mt-2 w-full"
        error={responseSuccess === false ? true : false}
        label={title}
        onChange={(e) => setVal(e.target.value)}
        size="small"
        type={type}
        value={val}
        InputProps={{
          startAdornment:
            type === "number" ? <InputAdornment position="start">$</InputAdornment> : null,
        }}
      />
    );
  } else if (type === "boolean") {
    return (
      <FormControl className="flex-row items-center">
        <label className="my-1 mr-2 font-bold">{title}: </label>
        <RadioGroup
          title={title}
          className="flex-row text-sm"
          name="radio-buttons-group"
          onChange={(e) => setVal(e.target.value)}
          value={val}
        >
          <FormControlLabel value={true} control={<Radio />} label={"True"} className="text-sm" />
          <FormControlLabel value={false} control={<Radio />} label={"False"} className="text-sm" />
        </RadioGroup>
      </FormControl>
    );
  } else if (type === "date") {
    // normalize various incoming shapes to a Date or null
    const normalizeDate = (v) => {
      if (v === null || v === undefined || v === "") {
        return null;
      }
      if (v instanceof Date) {
        return isValid(v) ? v : null;
      }
      if (typeof v === "string") {
        const parsed = parseISO(v);
        return isValid(parsed)
          ? parsed
          : (() => {
              const d = new Date(v);
              return isValid(d) ? d : null;
            })();
      }
      if (typeof v === "object" && v !== null) {
        if (typeof v.iso === "string") {
          const parsed = parseISO(v.iso);
          if (isValid(parsed)) {
            return parsed;
          }
        }
        // try toString fallback
        try {
          const s = String(v);
          const parsed = parseISO(s);
          if (isValid(parsed)) {
            return parsed;
          }
        } catch {
          return null;
        }
      }
      return null;
    };

    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DesktopDatePicker
          className="my-1 w-full text-center"
          label={title}
          value={normalizeDate(val)}
          onChange={(newValue) => {
            if (!newValue) {
              setVal(null);
              return;
            }
            const dateObj = newValue instanceof Date ? newValue : new Date(newValue);
            if (!isValid(dateObj)) {
              setVal(null);
              return;
            }
            setVal(format(dateObj, "yyyy-MM-dd"));
          }}
          slotProps={{
            textField: {
              variant: "outlined",
              error: responseSuccess === false ? true : false,
            },
          }}
        />
      </LocalizationProvider>
    );
  } else if (type === "search-select" || type === "select" || type === "multi-search-select") {
    return (
      <div className="my-1 w-full text-center">
        <AutoCompleteSearch
          activeEditObj={activeEditObj}
          apiUrl={apiUrl}
          customLimit={customLimit}
          displayKey={displayNameKey}
          error={responseSuccess === false ? true : false}
          keyVal={keyVal}
          multiple={type === "multi-search-select"}
          nullable={nullable}
          setVal={setVal}
          title={title}
        />
      </div>
    );
  } else if (type === "address") {
    return (
      <div className="my-1 w-full text-center">
        <SmartyAutoComplete address={val} setAddress={setVal} />
      </div>
    );
  } else {
    return null;
  }
}
